export class SlideshowNavigation {
  type = 'uk-thumbnav';
  verticalNavigation = '';
  position = 'uk-position-bottom-center';
  margin = 'uk-position-small';
  breakpoint = 'uk-visible';
  color = 'uk-light';
  thumbnailWidth = 75;
  thumbnailHeight = 50;
  noMultipleLines = '';

  static normalize(styles: Partial<SlideshowNavigation>): SlideshowNavigation {
    const pureStyles = new SlideshowNavigation();

    pureStyles.type = styles.type ?? pureStyles.type;
    pureStyles.verticalNavigation = styles.verticalNavigation ?? pureStyles.verticalNavigation;
    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.breakpoint = styles.breakpoint ?? pureStyles.breakpoint;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.thumbnailWidth = styles.thumbnailWidth ?? pureStyles.thumbnailWidth;
    pureStyles.thumbnailHeight = styles.thumbnailHeight ?? pureStyles.thumbnailHeight;
    pureStyles.noMultipleLines = styles.noMultipleLines ?? pureStyles.noMultipleLines;

    return pureStyles;
  }
}
